import React, { Fragment, useMemo } from 'react'
import PropTypes from 'prop-types'
import { isNilEmpty } from 'Utils'
import TileSlider from 'Components/TileSlider'
import SvgIcon from 'Components/SvgIcon'
import FadeInOnMount from 'Components/Transitions/FadeInOnMount'
import { isAreaSelectedChecker, checkDirectAreaLevelExist } from '../../utils'

import {
  _AreaBoxContainer, _AreaBox, _NeighbourhoodCount, _AreaBoxCloseIcon, _ViewMoreChildren,
  _SelectedChildCount, _DiscoveryAreaBoxes, _AreaBoxPlaceHolder,
} from './styles'


export const AreaBoxPlaceHolder = () => (
  <Fragment>
    <_AreaBoxPlaceHolder />
    <_AreaBoxPlaceHolder />
    <_AreaBoxPlaceHolder />
    <_AreaBoxPlaceHolder />
    <_AreaBoxPlaceHolder />
    <_AreaBoxPlaceHolder />
  </Fragment>
)

const AreaBoxListSlider = (
  {
    isDiscoveryAreaOpen,
    lookups,
    lcaMapTree,
    selectedSubLocality,
    childParentMap,
    lastSearchObj,
    googleAnalyticsEvent,
    setDiscoveryAreaOpenState,
    setSelectedSubLocality,
    setHoveredDiscoveryArea,
    calculateLcaAndSelectedAreas,
    filterByViewPort,
  }) => {
  const renderAreaBox = () => {
    if(!lcaMapTree) return null
    const city = lookups && lcaMapTree[`${lookups.areaType}_${lookups.areaId}`]
    return city && city.children.map(child => {
      const childArea = lcaMapTree[child]
      const currentlyActiveArea = selectedSubLocality && selectedSubLocality.areaId === childArea.areaId
      const hasDirectAreaLevel = checkDirectAreaLevelExist(city, childArea)
      const childrenCount = childArea.children.length
      const childrenSelected =
        !filterByViewPort && childParentMap && childParentMap[child]
          ? childParentMap[child].length
          : null
      const isSelected =
        !filterByViewPort && !childrenSelected &&
        isAreaSelectedChecker(childArea, lastSearchObj, lookups)
      const areaLabel = lcaMapTree[child].label
      return (
        <_AreaBoxContainer key={'renderAreaBox' + child} center>
          <_AreaBox
            center
            data-test-id={'areaSliderBox' + (isSelected ? 'Active' : '')}
            direction={'col'}
            isSelected={isSelected}
            childrenSelected={childrenSelected}
            onMouseLeave={() => { setHoveredDiscoveryArea(null) }}
            onHover={() => { setHoveredDiscoveryArea(childArea) }}
            onClick={() => {
              calculateLcaAndSelectedAreas(
                `${childArea.areaType}_${childArea.areaId}`,
                isSelected,
              )
              setSelectedSubLocality(null)
              setDiscoveryAreaOpenState(false)
              googleAnalyticsEvent({
                category: 'search',
                action: [
                  'Discovery area slider area box click',
                  childArea.areaType,
                ],
              })
            }}
          >
            <div>{lcaMapTree[child].label}</div>
            {
              (childrenSelected || (hasDirectAreaLevel && isSelected)) && (
                <_NeighbourhoodCount>
                  {childrenCount > 1 ? childrenCount : ''}
                  {' Neighbourhoods'}
                </_NeighbourhoodCount>
              )
            }
            {
              isSelected && (
                <_AreaBoxCloseIcon>
                  <SvgIcon height={8} width={8} name={'#icon-slim-close'} />
                </_AreaBoxCloseIcon>
              )
            }
          </_AreaBox>
          {
            (childrenSelected || (hasDirectAreaLevel && isSelected)) && (
              <FadeInOnMount type={'fade-left'}>
                <_ViewMoreChildren
                  currentlyActiveArea={currentlyActiveArea}
                  aria-label={`View more sub-area in ${areaLabel}`}
                  onClick={() => {
                    googleAnalyticsEvent({
                      category: 'search',
                      action: [
                        'Discovery area slider area box arrow click',
                        currentlyActiveArea ? 'close' : 'open',
                      ],
                    })
                    setSelectedSubLocality(currentlyActiveArea ? null : childArea)
                  }}
                >
                  {
                    childrenSelected && (
                      <_SelectedChildCount center>
                        <span>{childrenSelected}</span>
                      </_SelectedChildCount>
                    )
                  }

                  <div>
                    <SvgIcon
                      name={'#icon-dropdown-arrow'}
                      width={14}
                      height={14}
                    />
                  </div>
                </_ViewMoreChildren>
              </FadeInOnMount>
            )
          }
        </_AreaBoxContainer>
      )
    })
  }
  const areaBoxesComponents = useMemo(
    renderAreaBox,
    [childParentMap, selectedSubLocality, lcaMapTree, filterByViewPort],
  )
  return (
    <_DiscoveryAreaBoxes align={'center'}>
      {
        (!lookups.classType) && (
          <AreaBoxPlaceHolder />
        )
      }
      {
        lookups.classType && !isDiscoveryAreaOpen && !isNilEmpty(areaBoxesComponents) && (
          <TileSlider
            shouldSwiperUpdate
            key={'discoveryAreaSlider' + !lookups.classType}
            freeMode={false}
          >
            {areaBoxesComponents}
          </TileSlider>
        )
      }
    </_DiscoveryAreaBoxes>
  )
}

AreaBoxListSlider.defaultProps = {
  lookups: {},
}

AreaBoxListSlider.propTypes = {
  lookups: PropTypes.shape({
    areaType: PropTypes.string,
    areaId: PropTypes.number,
    classType: PropTypes.string,
  }),
  lcaMapTree: PropTypes.shape({
    [PropTypes.string]: PropTypes.shape({
      areaId: PropTypes.number,
      areaType: PropTypes.string,
      children: PropTypes.arrayOf(PropTypes.shape({})),
    }),
  }),
  isDiscoveryAreaOpen: PropTypes.bool,
  filterByViewPort: PropTypes.string,
  selectedSubLocality: PropTypes.shape({
    areaId: PropTypes.number,
  }),
  lastSearchObj: PropTypes.shape({}),
  googleAnalyticsEvent: PropTypes.func,
  setDiscoveryAreaOpenState: PropTypes.func,
  setSelectedSubLocality: PropTypes.func,
  setHoveredDiscoveryArea: PropTypes.func,
  calculateLcaAndSelectedAreas: PropTypes.func,
  childParentMap: PropTypes.shape({}),

}
export default AreaBoxListSlider
